import { render, staticRenderFns } from "./shelfasset.vue?vue&type=template&id=a164b0fe&scoped=true"
import script from "./shelfasset.vue?vue&type=script&lang=js"
export * from "./shelfasset.vue?vue&type=script&lang=js"
import style0 from "./shelfasset.vue?vue&type=style&index=0&id=a164b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a164b0fe",
  null
  
)

component.options.__file = "shelfasset.vue"
export default component.exports